import { endPoints, methods } from "../environment"
import generateApiSliceAndThunk from "../thunk"


const { slice: logedInUser, request: loginRequest } = generateApiSliceAndThunk(
  "logedInUser",
  endPoints.login,
  methods.post
)
const { request: getCSRFThunk } = generateApiSliceAndThunk(
  "getCSRF",
  endPoints.getCSRF,
  methods.get
)

const {slice: verifyToken, request: verifyTokenThunk } = generateApiSliceAndThunk(
  "verifyToken",
  endPoints.auth.verifyToken,
  methods.post
)

export { getCSRFThunk, logedInUser, loginRequest, verifyTokenThunk, verifyToken }

